package com.ai.mitra.di

import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.ImageBitmap
import androidx.compose.ui.graphics.toComposeImageBitmap
import androidx.compose.ui.platform.ClipboardManager
import androidx.compose.ui.text.style.TextDecoration
import androidx.compose.ui.unit.dp
import com.ai.mitra.domain.model.ChatMessage
import com.ai.mitra.domain.model.Group
import com.ai.mitra.theme.whiteColor
import com.ai.mitra.utils.AppCoroutineDispatchers
import com.ai.mitra.utils.TYPE
import com.mohamedrejeb.richeditor.annotation.ExperimentalRichTextApi
import com.mohamedrejeb.richeditor.model.RichTextState
import com.mohamedrejeb.richeditor.ui.material3.RichText
import com.mohamedrejeb.richeditor.ui.material3.RichTextEditor
import io.github.xxfast.kstore.KStore
import io.github.xxfast.kstore.storage.storeOf
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.CoroutineDispatcher
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.skia.Image
import org.khronos.webgl.ArrayBuffer
import org.khronos.webgl.Uint8Array
import org.khronos.webgl.get
import org.w3c.dom.HTMLInputElement
import org.w3c.files.FileReader
import org.w3c.files.get
import kotlin.coroutines.resume
import kotlin.coroutines.resumeWithException
import kotlin.coroutines.suspendCoroutine

actual fun getPlatform(): TYPE = TYPE.WEB


actual class AppCoroutineDispatchersImpl actual constructor() : AppCoroutineDispatchers {
    override val io: CoroutineDispatcher
        get() = Dispatchers.Default
    override val default: CoroutineDispatcher
        get() = Dispatchers.Default
    override val main: CoroutineDispatcher
        get() = Dispatchers.Main
}

actual suspend fun clipData(clipboardManager: ClipboardManager): String? {
    return window.navigator.clipboard.readText().toString().trim()
}
actual suspend fun setClipData(clipboardManager: ClipboardManager,message:String){
    window.navigator.clipboard.writeText(message)
}

@OptIn(ExperimentalRichTextApi::class)
@Composable
actual fun TextComposable(message:String,isGEMINIMessage:Boolean) {
    val richTextState = remember {
        RichTextState().apply {
            setMarkdown(message)
        }
    }
    // Link appearance
    richTextState.config.linkColor = Color.Blue
    richTextState.config.linkTextDecoration = TextDecoration.Underline

// Code block appearance
    richTextState.config.codeSpanColor = Color.Yellow
    richTextState.config.codeSpanBackgroundColor = Color.Transparent
    richTextState.config.codeSpanStrokeColor = Color.LightGray

    // Global list indentation
    richTextState.config.listIndent = 20

// Specific list type indentation
    richTextState.config.orderedListIndent = 20
    richTextState.config.unorderedListIndent = 20


    // 2. Wrap the RichTextEditor in a container and pass the readOnly parameter.
    RichText(
        modifier = Modifier.padding(
            start = 10.dp,
            top = 10.dp,
            end = 10.dp,
            bottom = if (isGEMINIMessage) 3.dp else 10.dp
        ),
        state = richTextState,
        color = whiteColor
    )

    /*Text(
        modifier = Modifier.padding(
            start = 10.dp,
            top = 10.dp,
            end = 10.dp,
            bottom = if (isGEMINIMessage) 3.dp else 10.dp
        ),
        text = richTextState.toHtml(),
        color = whiteColor,
        fontFamily = FontFamily.Cursive,
        style = MaterialTheme.typography.bodyMedium,
    )*/
}


@Composable
actual fun ImagePicker(showFilePicker: Boolean, onDismissDialog : () -> Unit, onResult: (ByteArray?) -> Unit) {
    val scope = rememberCoroutineScope()
    if (showFilePicker) {
        scope.launch {
            onResult(importImage())
        }
        onDismissDialog()
    }
}

private suspend fun importImage(): ByteArray? = suspendCoroutine { cont ->
    try {
        val input = document.createElement("input").apply {
            setAttribute("type", "file")
            setAttribute("accept",  "image/jpeg, image/png, image/jpg")
        } as HTMLInputElement

        input.onchange = {
            val file = input.files?.get(0)
            if (file != null) {
                val reader = FileReader()
                reader.onload = { event ->
                    val arrayBuffer = (event.target as FileReader).result as ArrayBuffer
                    val array = Uint8Array(arrayBuffer)

                    cont.resume(ByteArray(array.length) { array[it] })
                }
                reader.onerror = {
                    cont.resumeWithException(Exception(reader.error.toString()))
                }
                reader.readAsArrayBuffer(file)
            } else {
                cont.resumeWithException(Exception("No file was selected"))
            }
        }
        input.click()
    } catch (e: Exception) {
        cont.resumeWithException(e)
    }
}

actual fun ByteArray.toComposeImageBitmap(): ImageBitmap {
    return Image.makeFromEncoded(this).toComposeImageBitmap()
}

actual fun isNetworkAvailable(): Boolean {
    return window.navigator.onLine
}

actual suspend fun readGroupKStore(readFun : suspend(KStore<List<Group>>) -> Unit){
    val store: KStore<List<Group>> = storeOf(key = "group_db")
    readFun(store)
}
actual suspend fun readChatMessageKStore(readFun : suspend(KStore<List<ChatMessage>>) -> Unit) {
    val store: KStore<List<ChatMessage>> = storeOf(key = "chat_db")
    readFun(store)
}

@Composable
actual fun AdMobBanner() {
}